import Head from "next/head";

export default function LicensePage() {
  return (
    <div className="container d-flex flex-grow-1">
      <Head>
        <title>ใบอนุญาตสำหรับเว็บไซต์ | {process.env.appName}</title>
        <meta
          name="description"
          content={`ใบอนุญาตสำหรับเว็บไซต์ | ${process.env.appName}`}
        />
        <meta name="robots" content="noindex" />
        <meta
          name="og:title"
          content={`ใบอนุญาตสำหรับเว็บไซต์ | ${process.env.appName}`}
        />
        <meta
          name="og:description"
          content={`ใบอนุญาตสำหรับเว็บไซต์ | ${process.env.appName}`}
        />
      </Head>
      <main className="w-100">
        <div className="mt-2 mb-1 card">
          <div className="px-4 py-2 my-2">
            <h1 className="h4">ใบอนุญาตสำหรับเว็บไซต์ {process.env.appName}</h1>
            <p>
              บางส่วนของซอฟต์แวร์ {process.env.appName}&nbsp;
              อาจใช้เนื้อหาที่มีลิขสิทธิ์
              ซึ่งการใช้งานข้อมูลดังกล่าวได้รับการยินยอมแล้ว
              ตามข้อกำหนดของสิทธิ์การใช้งานต่อไปนี้
            </p>
            <ul
              className="mt-2 mb-2 list-group list-group-flush"
              id="info-accordion"
            >
              <li className="list-group-item">
                <p className="mb-0">สิทธิ์การใช้งาน PyThaiNLP</p>
                <br />
                <p className="mb-0">
                  Apache License 2.0 <br />
                  Copyright (c) 2016, Wannaphong Phatthiyaphaibun, Korakot
                  Chaovavanich, Charin Polpanumas, Arthit Suriyawongkul, Lalita
                  Lowphansirikul, {"&"} Pattarawat Chormai
                  <br />
                  <br />
                  อนุญาตให้ใช้สิทธิ์ภายใต้ Apache License รุ่น 2.0
                  (&#34;สิทธิ์การใช้งาน&#34;) ห้ามมิให้ใช้งานไฟล์นี้
                  เว้นแต่จะสอดคล้องกับสิทธิ์การใช้งาน
                  คุณสามารถขอรับสำเนาของสิทธิ์การใช้งานนี้ได้ที่ <br />
                  <br />
                  <a
                    href="http://www.apache.org/licenses/LICENSE-2.0"
                    target="_blank"
                    rel="noreferrer"
                  >
                    http://www.apache.org/licenses/LICENSE-2.0
                  </a>
                  <br />
                  <br />
                  การแจกจ่ายซอฟต์แวร์ภายใต้สิทธิ์การใช้งานเป็นการแจกจ่าย
                  &#34;ตามสภาพที่เป็นอยู่&#34;
                  โดยไม่มีการรับประกันหรือเงื่อนไขในลักษณะใดๆ
                  ไม่ว่าโดยชัดแจ้งหรือโดยนัย
                  เว้นแต่กฎหมายที่เกี่ยวข้องกำหนดไว้หรือตกลงกันเป็นลายลักษณ์อักษร
                  ดูสิทธิ์การใช้งานในข้อความเฉพาะ
                  ซึ่งควบคุมการอนุญาตและการจำกัดภายใต้สิทธิ์การใช้งาน
                  <br />
                  <br />
                  <a
                    href="https://github.com/PyThaiNLP/pythainlp/blob/dev/LICENSE"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ข้อกำหนดการใช้งาน
                  </a>
                </p>
              </li>
              <li className="list-group-item">
                <p className="mb-0">สิทธิ์การใช้งาน พจนานุกรมเล็กซิตรอน</p>
                <br />
                <p className="mb-0">
                  Copyright (c) 2003 National Electronics and Computer
                  Technology Center (NECTEC).
                  <br />
                  <br />
                  ผลิตภัณฑ์นี้สร้างสรรค์ขึ้นโดยดัดแปลงมาจากพจนานุกรมเล็กซิตรอนซึ่งพัฒนาโดย
                  ศูนย์เทคโนโลยีอิเล็กทรอนิกส์และคอมพิวเตอร์แห่งชาติ (
                  <a
                    href="http://www.nectec.or.th"
                    target="_blank"
                    rel="noreferrer"
                  >
                    http://www.nectec.or.th
                  </a>
                  )
                  <br />
                  <br />
                  <a
                    href="http://www.sansarn.com/lexto/license/LICENSE.php"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ข้อกำหนดการใช้งาน
                  </a>
                </p>
              </li>
              <li className="list-group-item border-top">
                <p className="mb-0">สิทธิ์การใช้งาน React</p>
                <br />
                <p>
                  The MIT License (MIT)
                  <br />
                  Copyright (c) Facebook, Inc. and its affiliates.
                  <br />
                  <br />
                  อนุญาตสิทธิ์ไว้ ณ ที่นี้โดยไม่มีค่าใช้จ่าย
                  ให้กับบุคคลที่ได้รับสำเนาของซอฟต์แวร์นี้และไฟล์เอกสารประกอบที่เกี่ยวข้อง
                  (&#34;ซอฟต์แวร์&#34;) เพื่อการจัดการซอฟต์แวร์โดยไม่มีข้อจำกัด
                  ซึ่งรวมถึงและไม่จำกัดเฉพาะสิทธิ์ในการใช้ ทำสำเนา ดัดแปลงแก้ไข
                  ผสาน เผยแพร่ แจกจ่าย อนุญาตให้ใช้สิทธิ์ต่อ
                  และ/หรือจำหน่ายสำเนาของซอฟต์แวร์
                  และให้อนุญาตบุคคลที่ได้รับการจัดหาซอฟต์แวร์ดังกล่าว
                  โดยเป็นไปตามเงื่อนไขต่อไปนี้
                  <br />
                  <br />
                  ข้อความสงวนลิขสิทธิ์ข้างต้นและข้อความอนุญาตนี้จะต้องรวมไว้ในสำเนาทั้งหมดหรือส่วนต่างๆ
                  ที่มีความสำคัญของซอฟต์แวร์นี้
                  <br />
                  <br />
                  ข้อความสงวนลิขสิทธิ์ข้างต้นและข้อความอนุญาตนี้จะต้องรวมไว้ในสำเนาทั้งหมดหรือส่วนต่างๆ
                  ที่มีความสำคัญของซอฟต์แวร์นี้
                  สิทธิ์การใช้งานซอฟต์แวร์นี้สอดคล้องกับ MIT License มาตรฐาน
                  ซอฟต์แวร์นี้ได้รับการจัดหาให้ &#34;ตามสภาพที่เป็นอยู่&#34;
                  โดยไม่มีการรับประกันในลักษณะใดๆ ไม่ว่าโดยชัดแจ้งหรือโดยนัย
                  ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะการรับประกันเกี่ยวกับการใช้ประโยชน์เชิงพาณิชย์
                  ความเหมาะสมในการใช้งานสำหรับวัตถุประสงค์อย่างใดอย่างหนึ่งเป็นการเฉพาะ
                  และการไม่ละเมิด
                  ผู้สร้างหรือผู้ถือครองลิขสิทธิ์ไม่มีหน้าที่รับผิดชอบต่อการเรียกร้อง
                  ค่าเสียหาย หรือความรับผิดอื่นใดไม่ว่ากรณีใดก็ตาม
                  ไม่ว่าจะเป็นการกระทำตามสัญญา การละเมิด และการกระทำอื่นใด
                  ซึ่งเกิดขึ้นจากหรือเกี่ยวข้องกับซอฟต์แวร์
                  หรือการใช้หรือการจัดการอื่นๆ กับซอฟต์แวร์
                  <br />
                  <br />
                  <a
                    href="https://github.com/facebook/react/blob/main/LICENSE"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ข้อกำหนดการใช้งาน
                  </a>
                </p>
              </li>
              <li className="list-group-item border-top">
                <p className="mb-0">สิทธิ์การใช้งาน Next.JS</p>
                <br />
                <p>
                  The MIT License (MIT)
                  <br />
                  Copyright (c) 2022 Vercel, Inc.
                  <br />
                  <br />
                  อนุญาตสิทธิ์ไว้ ณ ที่นี้โดยไม่มีค่าใช้จ่าย
                  ให้กับบุคคลที่ได้รับสำเนาของซอฟต์แวร์นี้และไฟล์เอกสารประกอบที่เกี่ยวข้อง
                  (&#34;ซอฟต์แวร์&#34;) เพื่อการจัดการซอฟต์แวร์โดยไม่มีข้อจำกัด
                  ซึ่งรวมถึงและไม่จำกัดเฉพาะสิทธิ์ในการใช้ ทำสำเนา ดัดแปลงแก้ไข
                  ผสาน เผยแพร่ แจกจ่าย อนุญาตให้ใช้สิทธิ์ต่อ
                  และ/หรือจำหน่ายสำเนาของซอฟต์แวร์
                  และให้อนุญาตบุคคลที่ได้รับการจัดหาซอฟต์แวร์ดังกล่าว
                  โดยเป็นไปตามเงื่อนไขต่อไปนี้
                  <br />
                  <br />
                  ข้อความสงวนลิขสิทธิ์ข้างต้นและข้อความอนุญาตนี้จะต้องรวมไว้ในสำเนาทั้งหมดหรือส่วนต่างๆ
                  ที่มีความสำคัญของซอฟต์แวร์นี้
                  <br />
                  <br />
                  ข้อความสงวนลิขสิทธิ์ข้างต้นและข้อความอนุญาตนี้จะต้องรวมไว้ในสำเนาทั้งหมดหรือส่วนต่างๆ
                  ที่มีความสำคัญของซอฟต์แวร์นี้
                  สิทธิ์การใช้งานซอฟต์แวร์นี้สอดคล้องกับ MIT License มาตรฐาน
                  ซอฟต์แวร์นี้ได้รับการจัดหาให้ &#34;ตามสภาพที่เป็นอยู่&#34;
                  โดยไม่มีการรับประกันในลักษณะใดๆ ไม่ว่าโดยชัดแจ้งหรือโดยนัย
                  ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะการรับประกันเกี่ยวกับการใช้ประโยชน์เชิงพาณิชย์
                  ความเหมาะสมในการใช้งานสำหรับวัตถุประสงค์อย่างใดอย่างหนึ่งเป็นการเฉพาะ
                  และการไม่ละเมิด
                  ผู้สร้างหรือผู้ถือครองลิขสิทธิ์ไม่มีหน้าที่รับผิดชอบต่อการเรียกร้อง
                  ค่าเสียหาย หรือความรับผิดอื่นใดไม่ว่ากรณีใดก็ตาม
                  ไม่ว่าจะเป็นการกระทำตามสัญญา การละเมิด และการกระทำอื่นใด
                  ซึ่งเกิดขึ้นจากหรือเกี่ยวข้องกับซอฟต์แวร์
                  หรือการใช้หรือการจัดการอื่นๆ กับซอฟต์แวร์
                  <br />
                  <br />
                  <a
                    href="https://github.com/vercel/next.js/blob/canary/license.md"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ข้อกำหนดการใช้งาน
                  </a>
                </p>
              </li>
              <li className="list-group-item border-top">
                <p className="mb-0">สิทธิ์การใช้งาน SWR</p>
                <br />
                <p>
                  The MIT License (MIT)
                  <br />
                  Copyright (c) 2019 ZEIT
                  <br />
                  <br />
                  อนุญาตสิทธิ์ไว้ ณ ที่นี้โดยไม่มีค่าใช้จ่าย
                  ให้กับบุคคลที่ได้รับสำเนาของซอฟต์แวร์นี้และไฟล์เอกสารประกอบที่เกี่ยวข้อง
                  (&#34;ซอฟต์แวร์&#34;) เพื่อการจัดการซอฟต์แวร์โดยไม่มีข้อจำกัด
                  ซึ่งรวมถึงและไม่จำกัดเฉพาะสิทธิ์ในการใช้ ทำสำเนา ดัดแปลงแก้ไข
                  ผสาน เผยแพร่ แจกจ่าย อนุญาตให้ใช้สิทธิ์ต่อ
                  และ/หรือจำหน่ายสำเนาของซอฟต์แวร์
                  และให้อนุญาตบุคคลที่ได้รับการจัดหาซอฟต์แวร์ดังกล่าว
                  โดยเป็นไปตามเงื่อนไขต่อไปนี้
                  <br />
                  <br />
                  ข้อความสงวนลิขสิทธิ์ข้างต้นและข้อความอนุญาตนี้จะต้องรวมไว้ในสำเนาทั้งหมดหรือส่วนต่างๆ
                  ที่มีความสำคัญของซอฟต์แวร์นี้
                  <br />
                  <br />
                  ข้อความสงวนลิขสิทธิ์ข้างต้นและข้อความอนุญาตนี้จะต้องรวมไว้ในสำเนาทั้งหมดหรือส่วนต่างๆ
                  ที่มีความสำคัญของซอฟต์แวร์นี้
                  สิทธิ์การใช้งานซอฟต์แวร์นี้สอดคล้องกับ MIT License มาตรฐาน
                  ซอฟต์แวร์นี้ได้รับการจัดหาให้ &#34;ตามสภาพที่เป็นอยู่&#34;
                  โดยไม่มีการรับประกันในลักษณะใดๆ ไม่ว่าโดยชัดแจ้งหรือโดยนัย
                  ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะการรับประกันเกี่ยวกับการใช้ประโยชน์เชิงพาณิชย์
                  ความเหมาะสมในการใช้งานสำหรับวัตถุประสงค์อย่างใดอย่างหนึ่งเป็นการเฉพาะ
                  และการไม่ละเมิด
                  ผู้สร้างหรือผู้ถือครองลิขสิทธิ์ไม่มีหน้าที่รับผิดชอบต่อการเรียกร้อง
                  ค่าเสียหาย หรือความรับผิดอื่นใดไม่ว่ากรณีใดก็ตาม
                  ไม่ว่าจะเป็นการกระทำตามสัญญา การละเมิด และการกระทำอื่นใด
                  ซึ่งเกิดขึ้นจากหรือเกี่ยวข้องกับซอฟต์แวร์
                  หรือการใช้หรือการจัดการอื่นๆ กับซอฟต์แวร์
                  <br />
                  <br />
                  <a
                    href="https://github.com/vercel/swr/blob/main/LICENSE"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ข้อกำหนดการใช้งาน
                  </a>
                </p>
              </li>
              <li className="list-group-item border-top">
                <p className="mb-0">สิทธิ์การใช้งาน Bootstrap</p>
                <br />
                <p>
                  The MIT License (MIT)
                  <br />
                  Copyright (c) 2011-2022 Twitter, Inc. Copyright (c) 2011-2022
                  <br />
                  The Bootstrap Authors
                  <br />
                  <br />
                  อนุญาตสิทธิ์ไว้ ณ ที่นี้โดยไม่มีค่าใช้จ่าย
                  ให้กับบุคคลที่ได้รับสำเนาของซอฟต์แวร์นี้และไฟล์เอกสารประกอบที่เกี่ยวข้อง
                  (&#34;ซอฟต์แวร์&#34;) เพื่อการจัดการซอฟต์แวร์โดยไม่มีข้อจำกัด
                  ซึ่งรวมถึงและไม่จำกัดเฉพาะสิทธิ์ในการใช้ ทำสำเนา ดัดแปลงแก้ไข
                  ผสาน เผยแพร่ แจกจ่าย อนุญาตให้ใช้สิทธิ์ต่อ
                  และ/หรือจำหน่ายสำเนาของซอฟต์แวร์
                  และให้อนุญาตบุคคลที่ได้รับการจัดหาซอฟต์แวร์ดังกล่าว
                  โดยเป็นไปตามเงื่อนไขต่อไปนี้
                  <br />
                  <br />
                  ข้อความสงวนลิขสิทธิ์ข้างต้นและข้อความอนุญาตนี้จะต้องรวมไว้ในสำเนาทั้งหมดหรือส่วนต่างๆ
                  ที่มีความสำคัญของซอฟต์แวร์นี้
                  <br />
                  <br />
                  ข้อความสงวนลิขสิทธิ์ข้างต้นและข้อความอนุญาตนี้จะต้องรวมไว้ในสำเนาทั้งหมดหรือส่วนต่างๆ
                  ที่มีความสำคัญของซอฟต์แวร์นี้
                  สิทธิ์การใช้งานซอฟต์แวร์นี้สอดคล้องกับ MIT License มาตรฐาน
                  ซอฟต์แวร์นี้ได้รับการจัดหาให้ &#34;ตามสภาพที่เป็นอยู่&#34;
                  โดยไม่มีการรับประกันในลักษณะใดๆ ไม่ว่าโดยชัดแจ้งหรือโดยนัย
                  ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะการรับประกันเกี่ยวกับการใช้ประโยชน์เชิงพาณิชย์
                  ความเหมาะสมในการใช้งานสำหรับวัตถุประสงค์อย่างใดอย่างหนึ่งเป็นการเฉพาะ
                  และการไม่ละเมิด
                  ผู้สร้างหรือผู้ถือครองลิขสิทธิ์ไม่มีหน้าที่รับผิดชอบต่อการเรียกร้อง
                  ค่าเสียหาย หรือความรับผิดอื่นใดไม่ว่ากรณีใดก็ตาม
                  ไม่ว่าจะเป็นการกระทำตามสัญญา การละเมิด และการกระทำอื่นใด
                  ซึ่งเกิดขึ้นจากหรือเกี่ยวข้องกับซอฟต์แวร์
                  หรือการใช้หรือการจัดการอื่นๆ กับซอฟต์แวร์
                  <br />
                  <br />
                  <a
                    href="https://github.com/twbs/bootstrap/blob/main/LICENSE"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ข้อกำหนดการใช้งาน
                  </a>
                </p>
              </li>
              <li className="list-group-item">
                <p className="mb-0">สิทธิ์การใช้งาน dotenv</p>
                <br />
                <p>
                  BSD 2-Clause &#34;Simplified&#34; License <br />
                  Copyright (c) 2015, Scott Motte
                  <br />
                  <br />
                  การแจกจ่ายซ้ำและการใช้งานในรูปแบบแหล่งที่มาและรูปแบบไบนารีจะมีหรือไม่มีการปรับเปลี่ยนก็ได้หากเป็นไปตามเงื่อนไขต่อไปนี้:
                  <br />
                  *
                  การแจกจ่ายซอร์สโค้ดซ้ำจะต้องคงไว้ซึ่งประกาศเกี่ยวกับลิขสิทธิ์ข้างต้นรายการเงื่อนไขนี้และข้อจำกัดความรับผิดชอบต่อไปนี้
                  <br />
                  *
                  การแจกจ่ายซ้ำในรูปแบบไบนารีต้องทำซ้ำประกาศลิขสิทธิ์ข้างต้นรายการเงื่อนไขนี้และข้อจำกัดความรับผิดชอบต่อไปนี้ในเอกสารประกอบและ
                  / หรือวัสดุอื่น ๆ ที่ให้มาพร้อมกับการแจกจ่าย
                  <br />
                  ซอฟต์แวร์นี้จัดทำโดยผู้ถือลิขสิทธิ์และผู้มีส่วนร่วม
                  &#34;ตามสภาพ&#34; และการรับประกันใด ๆ
                  โดยชัดแจ้งหรือโดยนัยซึ่งรวมถึง แต่ไม่ จำกัด
                  เพียงการรับประกันโดยนัยเกี่ยวกับความสามารถทางการค้าและความเหมาะสมสำหรับวัตถุประสงค์เฉพาะจะถูกปฏิเสธ
                  ไม่ว่าในกรณีใดก็ตามที่เจ้าของลิขสิทธิ์หรือผู้มีส่วนร่วมรับผิดชอบจะต้องรับผิดชอบต่อความเสียหายทั้งทางตรงทางอ้อมเหตุการณ์ที่เกิดขึ้นโดยเฉพาะความเสียหายที่ไม่อาจเกิดขึ้นได้
                  (รวมถึง แต่ไม่ จำกัด เพียงการจัดหาสินค้าหรือบริการใด ๆ ก็ตาม
                  หรือการหยุดชะงักทางธุรกิจ) ไม่ว่าจะเกิดขึ้นและอยู่ในทฤษฎีใด ๆ
                  ของความรับผิดไม่ว่าจะอยู่ในสัญญาความรับผิดอย่างเคร่งครัดหรือการละเมิด
                  (รวมถึงความประมาทหรือความเข้าใจอื่น ๆ )
                  ที่เกิดขึ้นไม่ว่าจะด้วยวิธีใดก็ตามจากการใช้ซอฟต์แวร์นี้แม้ว่าจะได้รับคำสั่งก็ตาม
                  <br />
                  <br />
                  <a
                    href="https://github.com/motdotla/dotenv/blob/master/LICENSE"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ข้อกำหนดการใช้งาน
                  </a>
                </p>
              </li>
              <li className="list-group-item">
                <p className="mb-0">สิทธิ์การใช้งาน Firebase Javascript SDK</p>
                <br />
                <p className="mb-0">
                  Apache License 2.0 <br />
                  Copyright (c) 2017 Google Inc.
                  <br />
                  <br />
                  อนุญาตให้ใช้สิทธิ์ภายใต้ Apache License รุ่น 2.0
                  (&#34;สิทธิ์การใช้งาน&#34;) ห้ามมิให้ใช้งานไฟล์นี้
                  เว้นแต่จะสอดคล้องกับสิทธิ์การใช้งาน
                  คุณสามารถขอรับสำเนาของสิทธิ์การใช้งานนี้ได้ที่ <br />
                  <br />
                  <a
                    href="http://www.apache.org/licenses/LICENSE-2.0"
                    target="_blank"
                    rel="noreferrer"
                  >
                    http://www.apache.org/licenses/LICENSE-2.0
                  </a>
                  <br />
                  <br />
                  การแจกจ่ายซอฟต์แวร์ภายใต้สิทธิ์การใช้งานเป็นการแจกจ่าย
                  &#34;ตามสภาพที่เป็นอยู่&#34;
                  โดยไม่มีการรับประกันหรือเงื่อนไขในลักษณะใดๆ
                  ไม่ว่าโดยชัดแจ้งหรือโดยนัย
                  เว้นแต่กฎหมายที่เกี่ยวข้องกำหนดไว้หรือตกลงกันเป็นลายลักษณ์อักษร
                  ดูสิทธิ์การใช้งานในข้อความเฉพาะ
                  ซึ่งควบคุมการอนุญาตและการจำกัดภายใต้สิทธิ์การใช้งาน
                  <br />
                  <br />
                  <a
                    href="https://github.com/firebase/firebase-js-sdk/blob/master/LICENSE"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ข้อกำหนดการใช้งาน
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </main>
    </div>
  );
}
